// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__1OfN-","info":"Note_info__2exQo","note":"Note_note__3jAyR","actions":"Note_actions__15pUx"};